<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    tag?: string;
    to?: string;
    size?: string;
    theme?: string;
    outline?: boolean;
    rounded?: boolean;
  }>(),
  {
    tag: "button",
    to: undefined,
    size: "md",
    theme: "primary",
    outline: false,
    rounded: false,
  },
);

const is = props.to ? "router-link" : props.tag;
const sizeClasses = (size: string) => {
  if (size === "lg") {
    return "px-8 py-3 text-lg leading-5";
  } else if (size === "sm") {
    return "px-4 py-1 text-sm leading-5";
  } else if (size === "xl") {
    return "text-xl py-1.5 px-6";
  } else if (size === "xs") {
    return "text-xs py-1.5 px-6";
  } else {
    return "px-5 py-2 text-base leading-5";
  }
};
const themeClasses = (theme: string) => {
  if (theme === "dark")
    return "bg-simply-blank hover:bg-green h-12 px-8 text-xl text-white";

  if (theme === "secondary")
    return "hover:bg-green hover:text-white h-12 px-8 text-xl";

  if (theme === "danger") return "bg-[#E44216] hover:bg-red-700 text-white";

  return "text-primary-text";
};

const classes = ref([
  "btn font-bold block cursor-pointer hover:bg-green font-extrabold font-helvetica flex justify-center items-center uppercase",
]);

classes.value.push(sizeClasses(props.size));
classes.value.push(themeClasses(props.theme));

if (props.outline) {
  classes.value.push("border-2 border-primary-text hover:border-green");
}

if (props.rounded) {
  classes.value.push("rounded-full");
}
</script>

<template>
  <component :is="is" :to="to" :class="classes" v-bind="$attrs">
    <slot />
  </component>
</template>
